<template>
    <div class="note-timeline">
        <RocketHeaderDilaog
            width="350px"
            top="10vh"
            :visible.sync="visibleSync"
        >
            <div class="header-title">
                <span style="margin-right: 10px; font-size: 24px">版本</span>
                更新公告
            </div>
            <el-timeline class="time-line">
                <el-timeline-item
                    v-for="note in notesList"
                    :key="note.key"
                    :timestamp="note.timestamp"
                    :color="note.color"
                >
                    {{ note.content }}
                    <span @click="handleToDetail(note)" class="detail-text">
                        详情
                    </span>
                </el-timeline-item>
            </el-timeline>
            <div class="btn-line">
                <el-button
                    type="danger"
                    plain
                    class="cancelBtn"
                    @click="visibleSync = false"
                >
                    关闭
                </el-button>
            </div>
        </RocketHeaderDilaog>
        <NotesDialog ref="notesDialogRef" @know="handleKnow" />
    </div>
</template>
<script>
import DialogFooter from "@/components/layout/DialogFooter.vue";
import RocketHeaderDilaog from "@/components/layout/RocketHeaderDilaog.vue";
import NotesDialog from "./NotesDialog.vue";
import bus from "@/utils/bus";
import { apiCallback } from "@/utils";
import { getNoticeList } from "@/api/sysMsg";
import {
    getUpdateNotesKnowConfig,
    saveUpdateNotesKnowConfig,
    pickAutoShowNotice,
} from "./utils";
export default {
    name: "TimelineNote",
    computed: {
        userPhone() {
            return this.$store.state.user.userphone;
        },
    },
    components: {
        DialogFooter,
        RocketHeaderDilaog,
        NotesDialog,
    },
    watch: {
        userPhone: {
            handler(newVal) {
                this.checkExperience(newVal);
            },
            immediate: true,
        },
    },
    data() {
        return {
            visibleSync: false,
            notesList: [],
            dialogHeaderImg: require("@/assets/img/dialogHeader.png"),
            curUpdateNotesKnowConfig: {},
        };
    },
    methods: {
        open() {
            this.visibleSync = true;
        },
        handleToDetail({ key }) {
            this.$refs.notesDialogRef.open(key);
        },
        handleKnow(key) {
            const id = String(key);
            if (this.curUpdateNotesKnowConfig[id] === "true") return;
            const cacheConfig = {
                ...this.curUpdateNotesKnowConfig,
                [id]: "true",
            };
            saveUpdateNotesKnowConfig(cacheConfig);
            if (id === "notes3") {
                this.$nextTick(() => {
                    bus.$emit("showUpdateNotesGuide", "notes3");
                });
            }
            this.curUpdateNotesKnowConfig = cacheConfig;
            this.$store.commit("user/editUpdateNotesKnowConfig", cacheConfig);
        },
        // 检查是否是内测用户
        checkExperience(phone) {
            this.$store.state.user.experiences.includes("speed");
            return new Promise((resolve, reject) => {
                const isExperience = ["speed", "abroad"].some((item) =>
                    this.$store.state.user.experiences.includes(item),
                );
                resolve(isExperience);
            });
        },
        // 获取更新公告列表
        loadNoticeList() {
            return new Promise((resolve, reject) => {
                getNoticeList({
                    pageNo: 1,
                    pageSize: 50,
                    status: "T",
                    type: 16,
                }).then((res) => {
                    const { records } = apiCallback(res);
                    const cacheList = records.map((item) => ({
                        content: item.title,
                        timestamp: item.subtitle,
                        key: item.id,
                    }));
                    this.notesList = cacheList;
                    resolve(cacheList);
                });
            });
        },
        // 获取更新公告查看状态；仅自动弹出一个月内的未读公告
        loadUpdateNotesKnowConfig(list) {
            getUpdateNotesKnowConfig().then((res) => {
                let cacheConfig = res || {};
                const isOldVersion = [
                    "notes9",
                    "notes8",
                    "notes7",
                    "notes6",
                    "notes5",
                    "notes4",
                ].some((item) => Boolean(cacheConfig[item]));
                if (isOldVersion) {
                    cacheConfig = list.reduce((acc, cur, index) => {
                        acc[String(cur.key)] = index === 0 ? "false" : "true";
                        return acc;
                    }, {});
                }
                const { needShowKey, config, expiredKeys } = pickAutoShowNotice(
                    list,
                    cacheConfig,
                );
                this.curUpdateNotesKnowConfig = config;
                this.$store.commit("user/editUpdateNotesKnowConfig", config);
                if (expiredKeys.length > 0) {
                    saveUpdateNotesKnowConfig(config);
                }
                if (!needShowKey) return;
                const openAuto = () => {
                    this.$refs.notesDialogRef.open(needShowKey, {
                        auto: true,
                    });
                };
                if (Number(needShowKey) === 97) {
                    this.checkExperience(this.userPhone).then((ok) => {
                        if (ok) openAuto();
                    });
                } else {
                    this.$nextTick(openAuto);
                }
            });
        },
        initFunc() {
            this.loadNoticeList().then((res) => {
                this.loadUpdateNotesKnowConfig(res);
            });
        },
    },
    mounted() {
        this.initFunc();
    },
};
</script>
<style lang="stylus" scoped>
.time-line{
    max-height: 50vh;
    overflow: auto;
    padding-top: 150px;
    padding-left:50px;
    user-select: none;
}

.header-title{
    text-align:center;
    font-size: 20px;
    position:absolute;
    top: -10px;
    right:20px;
    color: #fff;
    font-weight: bold;
    z-index: 9;
}
.btn-line{
    display:flex;
    justify-content:center;
    margin-top: 20px;
    width : 100%;
    padding-bottom: 20px;
}
.cancelBtn {
    color: white;
    background: linear-gradient(to right, #e5917e, #daacb9);
    border-radius: 15px;
    width:120px;
}

.detail-text{
    cursor:pointer;
    color:#c11c20;
    margin-left:10px;
}
</style>
